import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';

const TeamAttendance = () => {
    const { isSidebarOpen } = useSidebar();

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [attendances, setAttendances] = useState([
        // Sample data (replace with actual data)
        { selfie: 'path/to/selfie1.jpg', staffName: 'John Doe', staffId: 'S12345', checkInLocation: 'Office', checkOutLocation: 'Office', checkInDateTime: '2025-01-09 09:00', checkOutDateTime: '2025-01-09 17:00' },
        { selfie: 'path/to/selfie2.jpg', staffName: 'Jane Smith', staffId: 'S67890', checkInLocation: 'Office', checkOutLocation: 'Office', checkInDateTime: '2025-01-09 08:45', checkOutDateTime: '2025-01-09 16:30' },
        { selfie: 'path/to/selfie3.jpg', staffName: 'Alice Brown', staffId: 'S54321', checkInLocation: 'Remote', checkOutLocation: 'Remote', checkInDateTime: '2025-01-09 10:00', checkOutDateTime: '2025-01-09 18:00' },
    ]);
    const [filteredAttendances, setFilteredAttendances] = useState(attendances);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = attendances.filter((attendance) =>
            Object.values(attendance).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredAttendances(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, attendances]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredAttendances.length / itemsPerPage);
    const currentData = filteredAttendances.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h1 className="dashboard-title">Team Attendance</h1>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Team Attendance Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Selfie</th>
                                <th>Staff Name</th>
                                <th>Staff ID</th>
                                <th>Check-in Location</th>
                                <th>Check-out Location</th>
                                <th>Check-in Date Time</th>
                                <th>Check-out Date Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((attendance, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img
                                                src={attendance.selfie}
                                                alt="Staff Selfie"
                                                style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                                            />
                                        </td>
                                        <td>{attendance.staffName}</td>
                                        <td>{attendance.staffId}</td>
                                        <td>{attendance.checkInLocation}</td>
                                        <td>{attendance.checkOutLocation}</td>
                                        <td>{attendance.checkInDateTime}</td>
                                        <td>{attendance.checkOutDateTime}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>
                                        No attendance records found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    );
};

export default TeamAttendance;
